import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureTypesComponent } from './feature-types.component';
import { UbsViewContainersModule } from '@urbannex/view-containers';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UbsViewContainersModule,
  ]
})
export class FeatureTypesModule { }
